<!--
 * @Description: 列表中的支付进度弹层
 * @Date: 2020-12-17 19:49:41
-->
<template>
  <div>
    <div>
      <table class="app-info">
        <tbody>
          <tr>
            <td>
              <b>项目名称：</b>
              {{ row.projectName }}
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <div class="title">{{row.projectName}}</div> -->
      <!-- <div class="title">{{row.taskDt}}</div> -->
    </div>
    <table-render height="52vh" :config="config">
      <!-- 提示信息 start -->
      <template slot="top-alert">
        <el-row type="flex" justify="flex-start">
          <span class="error alert">
            由于每个自然月“供应商服务费率”有可能会有调整，故所有未生成订单内的“供应商服务费率”以及“结算总价”仅当月有效。
          </span>
        </el-row>
      </template>
    </table-render>
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import config from './config/index.js';
export default {
  components: { tableRender },
  name: 'payProgress',
  props: {
    row: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  // props:['orderId','structureType'],
  data() {
    return {
      config: null
    };
  },
  created() {
    config[0].childMenu[0].defaultQuery = {
      ...this.row
    };
    this.config = config;
  }
};
</script>

<style lang="scss" scoped>
.app-info {
  padding: 0 1.56vw;
  td {
    padding: 4px 8px;
    b {
      color: #606266;
      font-weight: 600;
    }
  }
}
</style>
